/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Time_FutureInputs */

const en_workflow_time_future = /** @type {(inputs: Workflow_Time_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event time can't be in the future.`)
};

const ja_workflow_time_future = /** @type {(inputs: Workflow_Time_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント時刻を未来に設定することはできません。`)
};

const fr_workflow_time_future = /** @type {(inputs: Workflow_Time_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’heure de l’événement ne peut pas être dans le futur.`)
};

const de_workflow_time_future = /** @type {(inputs: Workflow_Time_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereigniszeit darf nicht in der Zukunft liegen.`)
};

/**
* | output |
* | --- |
* | "Event time can't be in the future." |
*
* @param {Workflow_Time_FutureInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const workflow_time_future = /** @type {((inputs?: Workflow_Time_FutureInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Time_FutureInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_time_future(inputs)
	if (locale === "ja") return ja_workflow_time_future(inputs)
	if (locale === "fr") return fr_workflow_time_future(inputs)
	return de_workflow_time_future(inputs)
});